import axios from 'axios'
import {
    CHANGE_NAME,
    CHANGE_PHONE_NUMBER,
    CHANGE_AGE,
    CHANGE_GENDER,
    CHANGE_MARITAL_SATUS,
    CHANGE_BUDGET,
    CHANGE_UNIT_TYPE,
    CHANGE_MESSAGE,
    SUBMIT_CONTACT_SUCCESS,
    SUBMIT_CONTACT_FAILED,
} from './types'
import {
    RESPONSE_CODE_SUCCESS,
} from '../utils/Constants'
import {
    SUBMIT_CONTACT
} from '../api/EndPoint'

export const changeName = (text) => dispatch => {
    dispatch({
        type: CHANGE_NAME,
        payload: text
    })
}

export const changePhoneNumber = (text) => dispatch => {
    dispatch({
        type: CHANGE_PHONE_NUMBER,
        payload: text
    })
}

export const changeAge = (text) => dispatch => {
    dispatch({
        type: CHANGE_AGE,
        payload: text
    })
}

export const changeGender = (text) => dispatch => {
    dispatch({
        type: CHANGE_GENDER,
        payload: text
    })
}

export const changeMaritalStatus = (text) => dispatch => {
    dispatch({
        type: CHANGE_MARITAL_SATUS,
        payload: text
    })
}

export const changeBudget = (text) => dispatch => {
  //  console.log('budget', text)
    dispatch({
        type: CHANGE_BUDGET,
        payload: text
    })
}

export const changeUnitType = (text) => dispatch => {
    dispatch({
        type: CHANGE_UNIT_TYPE,
        payload: text
    })
}

export const changeMessage = (text) => dispatch => {
    dispatch({
        type: CHANGE_MESSAGE,
        payload: text
    })
}

export const submitContact = (props) => dispatch => {

    // console.log("submit: ",props)

    const {contact_us: {
        age, 
        budget, 
        gender, 
        marital_status, 
        message, 
        name, 
        phone_number,
        unit_type
        }, 
        param } = props

    const request = {
        age, 
        budget, 
        gender, 
        marital_status, 
        message, 
        name, 
        phone_number,
        unit_type,
        source: param === "" ? 'web': 'facebook'
    }

   // console.log("Request", request)

    axios({
        method: 'post',
        mode: 'no-cors',
        headers: {
        'Content-Type': 'application/json'
        },
        url: SUBMIT_CONTACT,
        data: request
    }).then( response => {

        if(response.data.code === RESPONSE_CODE_SUCCESS){

            dispatch({
                type: SUBMIT_CONTACT_SUCCESS,
                payload: true
            })

        }

    }).catch( error => {

        dispatch({
            type: SUBMIT_CONTACT_FAILED,
            payload: true
        })
        
    })


    dispatch({
        type: SUBMIT_CONTACT_SUCCESS,
        payload: true
    })

}

export const closeInformationDialog = (close) => dispatch =>{

    dispatch({
        type: SUBMIT_CONTACT_SUCCESS,
        payload: close
    })

}